import { render, staticRenderFns } from "./task-comment-attachment-viewer.vue?vue&type=template&id=66bb2e4e&scoped=true&"
import script from "./task-comment-attachment-viewer.vue?vue&type=script&lang=js&"
export * from "./task-comment-attachment-viewer.vue?vue&type=script&lang=js&"
import style0 from "./task-comment-attachment-viewer.vue?vue&type=style&index=0&id=66bb2e4e&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66bb2e4e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('66bb2e4e')) {
      api.createRecord('66bb2e4e', component.options)
    } else {
      api.reload('66bb2e4e', component.options)
    }
    module.hot.accept("./task-comment-attachment-viewer.vue?vue&type=template&id=66bb2e4e&scoped=true&", function () {
      api.rerender('66bb2e4e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tarefas/components/task-comment-attachment-viewer/task-comment-attachment-viewer.vue"
export default component.exports